<div class="Init">
  <header-bar></header-bar>

  <!-- ローディング -->
  <loading v-model:active="loader.is_loading" :is-full-page="loader.is_full_page"></loading>
  <!-- メッセージ -->
  <b-alert v-model="message.is_alert" dismissible :variant="message.variant">{{ message.message }}</b-alert>

  <b-container class="px-4">
    <div class="text-center mt-4">
      <img v-if="currentLocale === 'en'" :alt="$t('header.title')" src="../../assets/battery-care-image-500x256-EN.png" class="img-fluid" />
      <img v-else :alt="$t('header.title')" src="../../assets/battery-care-image-500x256-JP.png" class="img-fluid" />
    </div>
    <div class="text-center mt-4 mx-4">{{ $t('init.privacy_policy_prefix') }}<a href="/PrivacyPolicy">{{ $t('init.privacy_policy_link') }}</a></div>
    <div class="mt-3 d-grid gap-2">
      <b-button variant="outline-primary" class="btn" @click="home()">{{ $t('nav.about') }}</b-button>
    </div>
    <div class="mt-3 d-grid gap-2">
      <b-button variant="outline-primary" class="btn" @click="Guide()">{{ $t('nav.Guide') }}</b-button>
    </div>
    <div class="mt-3 d-grid gap-2">
      <b-button variant="outline-primary" class="btn" @click="privacy_policy()">{{ $t('nav.privacy_policy') }}</b-button>
    </div>
    <div class="mt-3 d-grid gap-2">
      <b-button variant="outline-primary" class="btn" @click="terms_of_service()">{{ $t('nav.terms_of_service') }}</b-button>
    </div>
  </b-container>
  
</div>